import styled from "styled-components";

export const HeaderTitleBox = styled.div`
  width:100%;
  text-align: center;
  color: ${props => props.theme.components.gamesListTitle.colors.text.regular};
  letter-spacing: 0.2rem;
  font-size: 1.5rem;
  color: ${props => props.theme.colors.brandSecondary};
  font-family: ${props => props.theme.font.family.bold};
  background-color: ${props => props.theme.colors.headerBackground};;
`;